import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {
    PageSupportTicketMessageModel,
    PageSupportTicketModel, SupportCategoryModel,
    SupportTicketBackOfficeRequest,
    SupportTicketMessageModel,
    SupportTicketMessageRequest,
    SupportTicketModel
} from '@services/back-office';
import {TicketsListFilterModel} from '@support/ngrx/reducers/support-service.reducer';

export const LoadTickets = createAction(
    '[Support Service] Load Tickets'
);

export const LoadTicketsSuccess = createAction(
    '[Support Service] Load Tickets Success',
    props<{ payload: { response: PageSupportTicketModel } }>()
);

export const LoadTicketsFailure = createAction(
    '[Support Service] Load Tickets Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const LoadMessages = createAction(
    '[Support Service] Load Messages',
    props<{ payload: { ticketId: string, clearState?: boolean } }>()
);

export const LoadMessagesSuccess = createAction(
    '[Support Service] Load Messages Success',
    props<{ payload: { ticketId: string, response: PageSupportTicketMessageModel, clearState?: boolean } }>()
);

export const LoadMessagesFailure = createAction(
    '[Support Service] Load Messages Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);

export const OpenMessages = createAction(
    '[Support Service] Open Messages',
    props<{ payload: { ticketId: string } }>()
);

export const SetMessagesNextPage = createAction(
    '[Support Service] Set Messages Next Page',
    props<{ payload: { ticketId: string } }>()
);


export const SendMessage = createAction(
    '[Support Service] Send Message',
    props<{ payload: { ticketId: string, request: SupportTicketMessageRequest } }>()
);

export const SendMessageSuccess = createAction(
    '[Support Service] Send Message Success',
    props<{ payload: { ticketId: string, response: SupportTicketMessageModel } }>()
);

export const SendMessageFailure = createAction(
    '[Support Service] Send Message Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const AddMessagesWS = createAction(
    '[Support Service] Add Messages WS',
    props<{ payload: { ticketId: string } }>()
);


export const ChangeStatus = createAction(
    '[Support Service] Change Status',
    props<{ payload: { ticketId: string, status: SupportTicketModel.StatusEnum, text?: string } }>()
);

export const ChangeStatusSuccess = createAction(
    '[Support Service] Change Status Success',
    props<{ payload: { ticketId: string, response: SupportTicketModel } }>()
);

export const ChangeStatusFailure = createAction(
    '[Support Service] Change Status Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const QuitTicket = createAction(
    '[Support Service] Quit Ticket',
    props<{ payload: { ticketId: string } }>()
);

export const QuitTicketSuccess = createAction(
    '[Support Service] Quit Ticket Success',
    props<{ payload: { ticketId: string } }>()
);

export const QuitTicketFailure = createAction(
    '[Support Service] Quit Ticket Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const SetManager = createAction(
    '[Support Service] Set Manager',
    props<{ payload: { ticketId: string, managerId: string } }>()
);

export const SetManagerSuccess = createAction(
    '[Support Service] Set Manager Success',
    props<{ payload: { ticketId: string, response: SupportTicketModel } }>()
);

export const SetManagerFailure = createAction(
    '[Support Service] Set Manager Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const AddManager = createAction(
    '[Support Service] Add Manager',
    props<{ payload: { ticketId: string, managerId: string } }>()
);

export const AddManagerSuccess = createAction(
    '[Support Service] Add Manager Success',
    props<{ payload: { ticketId: string, response: SupportTicketModel } }>()
);

export const AddManagerFailure = createAction(
    '[Support Service] Add Manager Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const RemoveManager = createAction(
    '[Support Service] Remove Manager',
    props<{ payload: { ticketId: string, managerId: string } }>()
);

export const RemoveManagerSuccess = createAction(
    '[Support Service] Remove Manager Success',
    props<{ payload: { ticketId: string, response: SupportTicketModel } }>()
);

export const RemoveManagerFailure = createAction(
    '[Support Service] Remove Manager Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const SetTicketsTab = createAction(
    '[Support Service] Set Tickets Tab',
    props<{ payload: { tab: 'SUPPORT' | 'FEATURE' } }>()
);

export const SetFilter = createAction(
    '[Support Service] Set Filter',
    props<{ payload: { filter: TicketsListFilterModel } }>()
);

export const ClearFilter = createAction(
    '[Support Service] Clear Filter'
);


export const UpsertTicket = createAction(
    '[Support Service] Ticket Update Success',
    props<{ payload: { response: SupportTicketModel } }>()
);


export const SetNextPage = createAction(
    '[Support Service] Set Next Page'
);


export const AddTicket = createAction(
    '[Support Service] Add Ticket',
    props<{ payload: { request: SupportTicketBackOfficeRequest } }>()
);

export const AddTicketSuccess = createAction(
    '[Support Service] Add Ticket Success',
    props<{ payload: { response: SupportTicketModel } }>()
);

export const AddTicketFailure = createAction(
    '[Support Service] Add Ticket Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const EditTicket = createAction(
    '[Support Service] Edit Ticket',
    props<{ payload: { request: SupportTicketBackOfficeRequest } }>()
);

export const EditTicketSuccess = createAction(
    '[Support Service] Edit Ticket Success',
    props<{ payload: { response: SupportTicketModel } }>()
);

export const EditTicketFailure = createAction(
    '[Support Service] Edit Ticket Failure',
    props<{ payload: { ticketId: string, error: HttpErrorResponse } }>()
);


export const DeleteTicket = createAction(
    '[Support Service] Delete Ticket',
    props<{ payload: { ticketId: string } }>()
);

export const DeleteTicketSuccess = createAction(
    '[Support Service] Delete Ticket Success',
    props<{ payload: { ticketId: string } }>()
);

export const DeleteTicketFailure = createAction(
    '[Support Service] Delete Ticket Failure',
    props<{ payload: { error: HttpErrorResponse, ticketId: string } }>()
);


export const LoadCategories = createAction(
    '[Knowledge Base] Load Categories'
);

export const LoadCategoriesSuccess = createAction(
    '[Knowledge Base] Load Categories Success',
    props<{ payload: { categories: SupportCategoryModel[] } }>()
);

export const LoadCategoriesFailure = createAction(
    '[Knowledge Base] Load Categories Failure',
    props<{ payload: { error: HttpErrorResponse } }>()
);


export const SetTicketFromQueryId = createAction(
    '[Knowledge Base] Set Ticket From Query Id',
    props<{ ticketId: string }>()
);
